import React, { useState } from 'react';
import {
  Grid,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import Modal from '../../../components/Modal';
import { Controls } from '../../../components/controls/Controls';
import AddAppointmentTypeModal from './AddAppointmentTypeModal';
import { convertAxiosErrorToUserFacingMessage, useApiClient } from '../../../context/ApiClientContext';
import basicServiceHandler from '../../../services/basicServiceHandler';
import AppointmentTypeTable from './AppointmentTypeTable';

export default function AppointmentTypeToIntakePlanMappingModal(props) {
  const {
    appointmentTypeSetting,
    isOpen,
    handleClose,
    intakePlanOptions,
    refreshParent,
    setSuccessMessage,
    setErrorMessage,
  } = props;
  const [addAppointmentTypeModalVisible, setAddAppointmentTypeModalVisible] = useState(false);
  const { siteId } = useParams();
  const apiClient = useApiClient();
  const [appointmentPlanPairs, setAppointmentPlanPairs] = useState(
    JSON.parse(appointmentTypeSetting.value),
  );

  const handleCloseAddAppointmentTypeModal = () => {
    setAddAppointmentTypeModalVisible(false);
  };

  const openAddAppointmentTypeModal = () => {
    setAddAppointmentTypeModalVisible(true);
  };

  const handleSave = () => {
    basicServiceHandler(
      () => apiClient.updateSiteSetting(siteId, {
        name: appointmentTypeSetting.name,
        value: JSON.stringify(appointmentPlanPairs),
        category: appointmentTypeSetting.category,
      }),
      () => {
        refreshParent();
        setSuccessMessage('Successfully updated setting');
      },
      (error) => {
        setErrorMessage(convertAxiosErrorToUserFacingMessage(error));
      },
    );
  };

  return (
    <>
      <AddAppointmentTypeModal
        isOpen={addAppointmentTypeModalVisible}
        handleClose={handleCloseAddAppointmentTypeModal}
        appointmentPlanPairs={appointmentPlanPairs}
        setAppointmentPlanPairs={setAppointmentPlanPairs}
      />
      <Modal
        isOpen={isOpen}
        handleClose={handleClose}
        size="md"
        title="Appointment Types"
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          rowSpacing={1}
        >
          <Controls.Button
            text="Add new type"
            onClick={openAddAppointmentTypeModal}
          />
          <Controls.Button
            text="Save"
            onClick={handleSave}
          />
        </Grid>
        <AppointmentTypeTable
          selectedPlans={intakePlanOptions}
          appointmentPlanPairs={appointmentPlanPairs}
          setAppointmentPlanPairs={setAppointmentPlanPairs}
        />
      </Modal>
    </>
  );
}

AppointmentTypeToIntakePlanMappingModal.propTypes = {
  appointmentTypeSetting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  intakePlanOptions: PropTypes.arrayOf(
    PropTypes.shape({
      actionListId: PropTypes.number,
      id: PropTypes.number,
      isIntakePlan: PropTypes.bool,
      languagesToTranslate: PropTypes.arrayOf(PropTypes.string),
      uniqueName: PropTypes.string,
    }),
  ).isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
};
